export const timeManagementColumns = "1fr 1fr 1fr 1fr";
